<template>
  <div id="cuckoo-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Cuckoo</h1>
    <form class="game-wrapper layout-1" @submit="listen">
      <div class="layout-content">
        <div id="cuckoos-number" v-if="current">{{ current }}</div>
      </div>
      <div class="layout-navigation">
        <button class="action-button" v-if="current == destination">Listen cuckoo</button>
      </div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

const CUCKOO_SOUND = '/audio/cuckoo/cuckoo_sound.mp3';

export default {
  data: function () {
    return {
      'destination': 0,
      'current': 0,
    }
  },
  methods: {
    listen: function (e) {
      e.preventDefault();
      this.$data.destination = Random.getNumber(60, 90);
      this.$data.current = 0;
      const cuckoo = new Audio(CUCKOO_SOUND);
      for (let i = 0; i < this.$data.destination; i++) {
        setTimeout(() => {
          this.$data.current++;
          cuckoo.play();
        }, i * 1000);
      }
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  div#cuckoo-game {
    background-image: url('../assets/img/game/cuckoo/bg.jpg');
  }

  #cuckoos-number {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
    width: 200px;
    height: 200px;
    text-align: center;
    line-height: 200px;
    font-size: 84pt;
    color: #ffffff;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 100px;
    box-shadow: 0 0 0 12px rgba(255, 255, 255, 0.7);
  }

</style>
